var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.sendVal.copyright)?_c('div',{ref:"box"},[_c('span',{ref:"box1",staticClass:"my-uname"},[_vm._v(_vm._s(_vm.sendVal.txt))])]):_c('div',{ref:"box1",staticClass:"my-uname"},[_vm._v(_vm._s(_vm.sendVal.txt))])}
var staticRenderFns = []

export { render, staticRenderFns }